import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, timeUnit) {
  const translations = timeUnit.get('info').get(language);
  const code = timeUnit.get('code');
  if (!translations) {
    throw new Error(
      `No translations available for time unit '${code}' with language '${language}'`
    );
  }
  return {
    code,
    text: translations.get('text'),
    textShort: translations.get('textShort'),
    slug: translations.get('slug')
  };
}

const getTimeUnitsMap = state => getStateSlice(state).get('timeUnits');
const getMarketTimeUnitsMap = state =>
  getStateSlice(state).get('marketTimeUnits');

export const getTimeUnits = createSelector(
  getTimeUnitsMap,
  timeUnitMap => timeUnitMap.toList()
);

export const getMarketTimeUnits = createSelector(
  getMarketTimeUnitsMap,
  timeUnitMap => timeUnitMap.toList()
);

export const getTimeUnitsTranslated = createSelector(
  getLanguage,
  getTimeUnits,
  (language, timeUnits) =>
    timeUnits.map(timeUnit => translate(language, timeUnit))
);

export const getTimeUnitTranslated = code => {
  return createSelector(
    getLanguage,
    getTimeUnitsMap,
    (language, timeUnitMap) => {
      if (!code) {
        return null;
      }
      const timeUnit = timeUnitMap.get(code);
      return translate(language, timeUnit);
    }
  );
};
